import * as yup from 'yup'

export class NeedsCANOwnershipMichiganEmailExporterDto {
  specialNotes?: string = undefined
  sentToEmailExporterDateTime?: string = undefined
}

export const needsCANOwnershipMichiganEmailExporterValidationSchema = yup.object({
  specialNotes: yup.string().max(2_000, 'Special Notes cannot be more than 2,000 characters.').nullable()
})
